var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "create-project-block container text-uppercase my-3" },
    [
      _c(
        "h6",
        { staticClass: "create-project-header d-flex justify-content-center" },
        [_vm._v("Select Project Type")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "wf-modal-button-close btn button-full",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              return _vm.$modal.hide("project-type-selection-modal")
            }
          }
        },
        [
          _c("span", {
            staticClass: "png-icon png-icon-icons-symbols--k-txtclose",
            attrs: { "aria-label": "Close modal" }
          })
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "my-3" }, [
        _c("p", [
          _vm._v(
            _vm._s(
              _vm.$resourceString["myProject.ProjectTypeSelection.Description"]
            )
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row mt-3" }, [
          _c("div", { staticClass: "col-md-6 mb-3" }, [
            _c("div", { staticClass: "form-check custom-radio h-100" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selectedType,
                    expression: "selectedType"
                  }
                ],
                staticClass: "form-check-input",
                attrs: {
                  type: "radio",
                  name: "projectType",
                  id: "personalProject",
                  value: "personal"
                },
                domProps: { checked: _vm._q(_vm.selectedType, "personal") },
                on: {
                  change: function($event) {
                    _vm.selectedType = "personal"
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "form-check-label",
                  attrs: { for: "personalProject" }
                },
                [_vm._v("\n            Create Personal Project\n          ")]
              )
            ])
          ]),
          _vm._v(" "),
          _vm.isAdmin
            ? _c("div", { staticClass: "col-md-6 mb-3" }, [
                _c("div", { staticClass: "form-check custom-radio h-100" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedType,
                        expression: "selectedType"
                      }
                    ],
                    staticClass: "form-check-input",
                    attrs: {
                      type: "radio",
                      name: "projectType",
                      id: "brandProject",
                      value: "brand"
                    },
                    domProps: { checked: _vm._q(_vm.selectedType, "brand") },
                    on: {
                      change: function($event) {
                        _vm.selectedType = "brand"
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label",
                      attrs: { for: "brandProject" }
                    },
                    [_vm._v("\n            Create Brand Project\n          ")]
                  )
                ])
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row mt-4" }, [
          _c("div", { staticClass: "col-12 text-center" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-success",
                attrs: { disabled: !_vm.selectedType },
                on: { click: _vm.confirmSelection }
              },
              [_vm._v("\n          Continue\n        ")]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }